import { SaveQuotationTaxUseCase } from '../../../domain/usecases/comercial/save-quotation-tax.usecase';
import { GetQuotationTaxesUseCase } from '../../../domain/usecases/comercial/get-quotation-taxes.usecase';
import { ComercialRepository } from "../../../domain/repositories/comercial.repository";
import { GetComercialAllUseCase } from "../../../domain/usecases/comercial/get-comercial-all.usecase";
import { InsertComercialUseCase } from "../../../domain/usecases/comercial/insert-comercial.usecase";
import { DeleteComercialUseCase } from '../../../domain/usecases/comercial/delete-comercial.usecase';
import { UpdateComercialUseCase } from "../../../domain/usecases/comercial/update-comercial.usecase";
import { GetTypeLicenseUseCase } from "../../../domain/usecases/comercial/type-license.usecase";
import { InsertFollowupUseCase } from "../../../domain/usecases/comercial/insert-followup.usecase";
import { GetFollowupByIdUseCase } from "../../../domain/usecases/comercial/get-followup-by-id-usecase";
import { GetValidateFollowupUseCase } from "../../../domain/usecases/comercial/get-validate-comercial-followup-usecase";
import { GetProductUseCase } from "../../../domain/usecases/comercial/get-product.usecase";
import { GetTeleconsultaInterestUseCase } from "../../../domain/usecases/comercial/get-teleconsulta-interest.usecase";
import { InsertTeleconsultaInterestUseCase } from "../../../domain/usecases/comercial/insert-teleconsulta-interest.usecase";
import { GetComercialPagedUseCase } from '../../../domain/usecases/comercial/get-comercial-paged.usecase';
import { GetComercialByIdUseCase } from '../../../domain/usecases/comercial/get-comercial-by-id.usecase';
import { DownloadCommercialDocumentUseCase } from "../../../domain/usecases/comercial/download-commercial-document.usecase";
import { DownloadSignedConsentDocumentUseCase } from "../../../domain/usecases/comercial/download-signed-consent-document.usecase";
import { GetFollowupReasonsUseCase } from "../../../domain/usecases/comercial/get-followup-reasons.usecase";
import { GetCommercialConsentUseCase } from "../../../domain/usecases/comercial/get-commercial-consent.usecase";
import { RespondCommercialConsentUseCase } from "../../../domain/usecases/comercial/respond-commercial-consent.usecase";
import { GetContractualValiditiesUseCase } from "../../../domain/usecases/comercial/get-contractual-validities.usecase";
import { ComercialV1QueryUseCase } from '../../../domain/usecases/comercial/comercial-v1-query.usecase';

const insertComercialUseCaseFactory =
(ComercialRepo: ComercialRepository) => new InsertComercialUseCase(ComercialRepo);
export const InsertComercialUseCaseProvider = {
    provide: InsertComercialUseCase,
    useFactory: insertComercialUseCaseFactory,
    deps: [ComercialRepository],
};

const insertFollowupUseCaseFactory =
(ComercialRepo: ComercialRepository) => new InsertFollowupUseCase(ComercialRepo);
export const InsertFollowupUseCaseProvider = {
    provide: InsertFollowupUseCase,
    useFactory: insertFollowupUseCaseFactory,
    deps: [ComercialRepository],
};

const getComercialAllUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetComercialAllUseCase(ComercialRepo);
export const  GetComercialAllUseCaseProvider= {
    provide: GetComercialAllUseCase,
    useFactory: getComercialAllUseCaseFactory,
    deps: [ComercialRepository],
};

const getComercialPagedUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetComercialPagedUseCase(ComercialRepo);
export const GetComercialPagedUseCaseProvider = {
    provide: GetComercialPagedUseCase,
    useFactory: getComercialPagedUseCaseFactory,
    deps: [ComercialRepository],
};

const getComercialByIdUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetComercialByIdUseCase(ComercialRepo);
export const GetComercialByIdUseCaseProvider = {
    provide: GetComercialByIdUseCase,
    useFactory: getComercialByIdUseCaseFactory,
    deps: [ComercialRepository],
};

const getFollowupByIdUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetFollowupByIdUseCase(ComercialRepo);
export const  GetFollowupByIdUseCaseProvider= {
    provide: GetFollowupByIdUseCase,
    useFactory: getFollowupByIdUseCaseFactory,
    deps: [ComercialRepository],
};

const getFollowupReasonsUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetFollowupReasonsUseCase(ComercialRepo);
export const GetFollowupReasonsUseCaseProvider = {
    provide: GetFollowupReasonsUseCase,
    useFactory: getFollowupReasonsUseCaseFactory,
    deps: [ComercialRepository],
};

const downloadCommercialDocumentUseCaseFactory =
(ComercialRepo: ComercialRepository) => new DownloadCommercialDocumentUseCase(ComercialRepo);
export const DownloadCommercialDocumentUseCaseProvider = {
    provide: DownloadCommercialDocumentUseCase,
    useFactory: downloadCommercialDocumentUseCaseFactory,
    deps: [ComercialRepository],
};


const downloadSignedConsentDocumentUseCaseFactory =
(ComercialRepo: ComercialRepository) => new DownloadSignedConsentDocumentUseCase(ComercialRepo);
export const DownloadSignedConsentDocumentUseCaseProvider = {
    provide: DownloadSignedConsentDocumentUseCase,
    useFactory: downloadSignedConsentDocumentUseCaseFactory,
    deps: [ComercialRepository],
};

const getValidateComercialFollowupUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetValidateFollowupUseCase(ComercialRepo);
export const  GetValidateFollowupUseCaseProvider= {
    provide: GetValidateFollowupUseCase,
    useFactory: getValidateComercialFollowupUseCaseFactory,
    deps: [ComercialRepository],
};

const getTypeLicenseUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetTypeLicenseUseCase(ComercialRepo);
export const  GetTypeLicenseUseCaseProvider= {
    provide: GetTypeLicenseUseCase,
    useFactory: getTypeLicenseUseCaseFactory,
    deps: [ComercialRepository],
};

const deleteComercialUseCaseFactory =
(ComercialRepo: ComercialRepository) => new DeleteComercialUseCase(ComercialRepo);
export const  DeleteComercialUseCaseProvider= {
    provide: DeleteComercialUseCase,
    useFactory: deleteComercialUseCaseFactory,
    deps: [ComercialRepository],
};

const updateComercialUseCaseFactory =
(ComercialRepo: ComercialRepository) => new UpdateComercialUseCase(ComercialRepo);
export const UpdateComercialUseCaseProvider = {
    provide: UpdateComercialUseCase,
    useFactory: updateComercialUseCaseFactory,
    deps: [ComercialRepository],
};


const getContractualValiditiesUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetContractualValiditiesUseCase(ComercialRepo);
export const GetContractualValiditiesUseCaseProvider = {
    provide: GetContractualValiditiesUseCase,
    useFactory: getContractualValiditiesUseCaseFactory,
    deps: [ComercialRepository],
};

const getProductUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetProductUseCase(ComercialRepo);
export const  GetProductUseCaseProvider= {
    provide: GetProductUseCase,
    useFactory: getProductUseCaseFactory,
    deps: [ComercialRepository],
};

const getTeleconsultaInterestUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetTeleconsultaInterestUseCase(ComercialRepo);
export const  GetTeleconsultaInterestUseCaseProvider= {
    provide: GetTeleconsultaInterestUseCase,
    useFactory: getTeleconsultaInterestUseCaseFactory,
    deps: [ComercialRepository],
};

const insertTeleconsultaInterestUseCaseFactory =
(ComercialRepo: ComercialRepository) => new InsertTeleconsultaInterestUseCase(ComercialRepo);
export const  InsertTeleconsultaInterestUseCaseProvider= {
    provide: InsertTeleconsultaInterestUseCase,
    useFactory: insertTeleconsultaInterestUseCaseFactory,
    deps: [ComercialRepository],
};



const getCommercialConsentUseCaseFactory =
(ComercialRepo: ComercialRepository) => new GetCommercialConsentUseCase(ComercialRepo);
export const GetCommercialConsentUseCaseProvider = {
    provide: GetCommercialConsentUseCase,
    useFactory: getCommercialConsentUseCaseFactory,
    deps: [ComercialRepository],
};

const respondCommercialConsentUseCaseFactory =
(ComercialRepo: ComercialRepository) => new RespondCommercialConsentUseCase(ComercialRepo);
export const RespondCommercialConsentUseCaseProvider = {
    provide: RespondCommercialConsentUseCase,
    useFactory: respondCommercialConsentUseCaseFactory,
    deps: [ComercialRepository],
};

const comercialV1QueryUseCaseFactory =
(ComercialRepo: ComercialRepository) => new ComercialV1QueryUseCase(ComercialRepo);
export const ComercialV1QueryUseCaseProvider = {
  provide: ComercialV1QueryUseCase,
  useFactory: comercialV1QueryUseCaseFactory,
  deps: [ComercialRepository],
};

export const GetQuotationTaxesUseCaseProvider = {
  provide: GetQuotationTaxesUseCase,
  useFactory: (repository: ComercialRepository) => new GetQuotationTaxesUseCase(repository),
  deps: [ComercialRepository],
};

export const SaveQuotationTaxUseCaseProvider = {
  provide: SaveQuotationTaxUseCase,
  useFactory: (repository: ComercialRepository) => new SaveQuotationTaxUseCase(repository),
  deps: [ComercialRepository],
};
